import type { Translations } from '../keys';

const frFR: Translations = {
  'common.search': 'Rechercher',
  'common.copied': 'Copié',
  'common.copy': 'Copier',
  'common.poweredBy': 'Propulsé par',
  'common.plan': 'Forfait',
  'common.banner': 'Bannière',
  'common.total': 'Total {value}',
  'common.installmentPrefix': '{count}x de',
  'common.discountCoupon': 'Code promo',
  'common.checkout': 'Paiement',
  'common.tryAgain': 'Réessayer',

  'app.loading': 'Chargement du paiement…',
  'app.init.error': 'Erreur lors de l’initialisation du paiement :',

  'checkout.title': 'Finalisez votre abonnement',
  'checkout.subtitle': 'Renseignez vos informations pour accéder à {productName}.',
  'checkout.greeting': 'Ravis de vous voir, {firstName}',
  'checkout.contactInfo': 'Informations de contact',
  'checkout.contact.namePlaceholder': 'Nom complet',
  'checkout.paymentMethod': 'Mode de paiement',
  'checkout.cardData': 'Informations de la carte',
  'checkout.card.maskPlaceholder': '•••• •••• •••• ••••',
  'checkout.card.expMonth': 'Mois',
  'checkout.card.expYear': 'Année',
  'checkout.card.cvv': 'CVV',
  'checkout.card.expiryPlaceholder': 'MM/AA',
  'checkout.card.holderName': 'Nom complet du titulaire de la carte',
  'checkout.document': 'Document',
  'checkout.document.cpfHolder': 'CPF du titulaire',
  'checkout.useFilledName': 'Utiliser le nom déjà saisi',
  'checkout.summary.ariaLabel': 'Récapitulatif de l’abonnement',
  'checkout.summary.community': 'Communauté',
  'checkout.summary.availablePlans': 'Forfaits disponibles',
  'checkout.summary.chooseAccess': 'Choisissez votre accès',
  'checkout.summary.buying': 'Vous achetez :',
  'checkout.summary.renewal': 'Renouvellement le {date}. Vous pouvez annuler à tout moment.',
  'checkout.theme.enableLight': 'Activer le thème clair',
  'checkout.theme.enableDark': 'Activer le thème sombre',
  'checkout.theme.light': 'Clair',
  'checkout.theme.dark': 'Sombre',
  'checkout.installments.title': 'Paiement en plusieurs fois',
  'checkout.installments.placeholder': 'Nombre de mensualités',
  'checkout.installments.discount': '{percent}% de réduction',
  'checkout.submit.generatePix': 'Générer le code PIX',
  'checkout.submit.buyLifetime': 'Acheter {productName} (accès à vie)',
  'checkout.submit.subscribe': 'S’abonner à {productName}',
  'checkout.footer.safeTransaction': 'Transaction sécurisée et chiffrée',
  'checkout.footer.termsPrefix': 'En confirmant votre achat, vous acceptez les',
  'checkout.footer.terms': 'Conditions d’utilisation de Ginastee',

  'checkout.notFound.eyebrow': 'Paiement indisponible',
  'checkout.notFound.title': 'Communauté introuvable',
  'checkout.notFound.description': 'Ce lien de paiement ne correspond pas à une communauté active. Vérifiez l’adresse ou contactez la communauté.',

  'checkout.paymentsUnavailable.message': 'Les paiements pour votre région ne sont pas encore disponibles — le responsable de la communauté doit finaliser la configuration de son portefeuille.',
  'checkout.paymentsUnavailable.action': 'En savoir plus',

  'coupon.title': 'Code promo',
  'coupon.placeholder': 'Saisissez le code',
  'coupon.notFound': 'Code promo introuvable',

  'pix.title': 'Finalisez le paiement via PIX',
  'pix.instructions': 'Ouvrez une application où PIX est activé, choisissez « Payer », puis « Lire le QR Code ».',
  'pix.scanQrCode': 'Scannez le QR Code ci-dessous dans l’application de votre banque',
  'pix.qrAlt': 'QR Code PIX',
  'pix.copyCode': 'Ou, si vous préférez, copiez-collez le code ci-dessous',
  'pix.timeLeft': 'Temps restant pour payer :',
  'pix.realtime': 'Mis à jour en temps réel',

  'thanks.confirming.title': 'Confirmation du paiement',
  'thanks.confirming.description': 'Nous attendons la confirmation du paiement avant de débloquer l’accès.',
  'thanks.failed.title': 'Paiement non confirmé',
  'thanks.failed.description': 'Nous n’avons pas pu confirmer votre paiement. Réessayez ou contactez le support.',
  'thanks.success.title': 'Félicitations !',
  'thanks.success.subtitle': 'Vous êtes abonné à {productName}',
  'thanks.success.emailSent': 'Un e-mail vous a été envoyé avec le lien d’accès à la plateforme.',
  'thanks.success.emailMissing': 'Vous n’avez pas encore reçu l’e-mail ?',
  'thanks.success.emailDelay': 'L’e-mail d’inscription arrive généralement sous 5 minutes.',
  'thanks.success.spamSupport': 'Si ce délai est dépassé, vérifiez vos spams ou envoyez un message au canal de support.',
  'thanks.success.supportButton': 'L’e-mail n’est toujours pas arrivé',

  'method.creditCard': 'Carte de crédit',
  'method.pix': 'PIX',

  'input.fullName.placeholder': 'Saisissez le nom complet',
  'input.phone.placeholder': 'Numéro de téléphone portable',
  'input.country.searchPlaceholder': 'Rechercher un pays',
  'input.date.label': 'Date',
  'input.date.placeholder': 'jj/mm/aaaa',
  'input.cpf.placeholder': '000.000.000-00',
  'input.money.label': 'Montant',
  'input.money.placeholder': '0,00 €',
  'input.cnpj.label': 'CNPJ',
  'input.cnpj.placeholder': '00.000.000/0000-00',
  'input.email.placeholder': 'email@exemple.com',
  'input.cardNumber.label': 'Numéro de carte',
  'input.cardNumber.placeholder': '0000 0000 0000 0000',

  'address.label': 'Adresse',
  'address.placeholder': 'Recherchez votre adresse',
  'address.noOptions': 'Aucune adresse trouvée',
  'address.number.label': 'Numéro',
  'address.number.placeholder': 'N°',
  'address.complement.label': 'Complément',
  'address.complement.placeholder': 'Appartement, bâtiment...',
  'address.neighborhood.label': 'Quartier',
  'address.zipcode.label': 'Code postal',
  'address.zipcode.placeholder': '00000',
  'address.city.label': 'Ville',
  'address.state.placeholder': 'Région',

  'stripe.error.generic': 'Une erreur est survenue lors du traitement du paiement, vérifiez les informations saisies et réessayez',
  'stripe.error.incompleteCard': 'Complétez les informations de carte pour continuer',
  'stripe.error.confirmPayment': 'Une erreur est survenue lors de la confirmation du paiement',
  'stripe.submit': 'Confirmer le paiement',

  'payment.error.generic': 'Une erreur est survenue lors du traitement du paiement, vérifiez les informations saisies et réessayez',
  'payment.error.prepare': 'Une erreur est survenue lors de la préparation du paiement, vérifiez les informations saisies et réessayez',
  'payment.error.missingCharge': 'Identifiant du paiement non retourné',
  'payment.error.notApproved': 'Paiement refusé. Vérifiez les informations de votre carte et réessayez.',

  'validation.cardNumber': 'Numéro de carte invalide',
  'validation.cardExpiration': 'Date d’expiration invalide',
  'validation.cardExpired': 'Carte expirée',
  'validation.cardCvv': 'CVV invalide',
  'validation.cpf': 'CPF invalide',
  'validation.fullName': 'Nom complet invalide',
  'validation.fullNameLettersOnly': 'Le nom ne doit contenir que des lettres',
  'validation.emailRequired': 'L’e-mail est obligatoire',
  'validation.emailInvalid': 'E-mail invalide',
  'validation.phoneRequired': 'Le téléphone est obligatoire',
  'validation.phoneInvalid': 'Téléphone invalide',
  'validation.phoneDigits': 'Le téléphone doit comporter 10 ou 11 chiffres',
  'validation.phoneMobileStartsWithNine': 'Le mobile doit commencer par 9',
  'validation.phoneDdd': 'Indicatif invalide',

  'interval.week.adjective': 'Hebdomadaire',
  'interval.month.adjective': 'Mensuel',
  'interval.bimonthly.adjective': 'Bimestriel',
  'interval.quarterly.adjective': 'Trimestriel',
  'interval.semiannual.adjective': 'Semestriel',
  'interval.year.adjective': 'Annuel',
  'interval.lifetime.adjective': 'À vie',
  'interval.week.noun': 'Semaine',
  'interval.month.noun': 'Mois',
  'interval.bimonthly.noun': 'Bimestre',
  'interval.quarterly.noun': 'Trimestre',
  'interval.semiannual.noun': 'Semestre',
  'interval.year.noun': 'Année',
  'interval.lifetime.noun': 'À vie',
  'interval.lifetime.access': 'accès à vie',
  'interval.period': 'période',

  'month.01': 'Janvier',
  'month.02': 'Février',
  'month.03': 'Mars',
  'month.04': 'Avril',
  'month.05': 'Mai',
  'month.06': 'Juin',
  'month.07': 'Juillet',
  'month.08': 'Août',
  'month.09': 'Septembre',
  'month.10Label': 'Octobre',
  'month.11Label': 'Novembre',
  'month.12': 'Décembre',
};

export default frFR;
